<template>

    <m-edit1/>

    <m-section v-bind='{...{},...{}}' :style='"\n"' class="container-fluid p-0" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="rom mx-auto justify-content-center text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"font-size: clamp(22px, 3vw, 34px);\ncolor:black;\nfont-weight:bold;\n\n"' class=" d-inline-block border-primary-buttom" >
                <template #default>تجربه خرید شما برای ما ارزشمند است 🌹   </template>
                </m-h2><m-h4 v-bind='{...{},...{}}' :style='"font-size:16px"' class="" >
                <template #default>اگر از  رونا چوب خرید کرده‌اید، نظر و تجربه خود را با ما به اشتراک بگذارید. نظر شما به ما کمک می‌کند خدمات بهتری ارائه دهیم و راهنمای خوبی برای سایر مشتریان باشد.   </template>
                </m-h4></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row  mx-auto justify-content-center text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-right  d-flex flex-column" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 16px;"' class="shadow mb-4 h-100 text-center" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":false,"redirectDirectLink":"https:\/\/nodano.ir\/submit-form"},...{}}' :style='""' class="form-single-1-wrapper py-5" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-section>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection from '@moeinmdn/miw-alpha-components/src/package/Tags/Section'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection,mDiv,mH2,mH4,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
